import { Button } from '@/components/ui/button';
import { useI18n } from '@/contexts/I18nContext';

interface AgeBlockedScreenProps {
  onBackToStart: () => void;
}

export const AgeBlockedScreen = ({ onBackToStart }: AgeBlockedScreenProps) => {
  const { t } = useI18n();

  return (
    <div className="w-full flex flex-col min-h-[calc(100dvh-140px)]">
      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-4 px-2 pb-8">
        <h2 className="text-2xl font-semibold text-white">
          {t('auth.age_blocked.title')}
        </h2>
        <p className="text-sm text-white/70 leading-relaxed max-w-sm">
          {t('auth.age_blocked.body')}
        </p>
      </div>

      <div className="sticky bottom-0 bg-sossiety-dark pt-3 pb-2">
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={onBackToStart}
          className="w-full"
        >
          {t('auth.age_blocked.back_to_start')}
        </Button>
      </div>
    </div>
  );
};
